import _APIInstance from "@/config/configApi";
import _APIInstanceServer from "@/config/configApiServer";
import {
  paramsPurchasedReports,
  paramsReport,
  paramsReportBookmark,
  reportFeaturedParams,
  reportParams,
} from "@/models/Params";
import { GetReports, reportMinimal } from "@/models/report";
import { API } from "@constants/common";

export class ReportServices {
  static async findAll(params: GetReports) {
    return await _APIInstance
      .get(API.REPORT.GET_ALL, { params: params })
      .then((res) => {
        return Promise.resolve(res.data);
      })
      .catch((e) => {
        return Promise.reject(e?.response?.data);
      });
  }

  static async getAllReport(params: reportParams) {
    try {
      const response = await _APIInstance.get(`${API.REPORT.GET_ALL}`, {
        params: params,
      });
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getDownloadReport(code: string | undefined, lang: string) {
    try {
      const response = await _APIInstance.get(
        `${API.REPORT.GET_DOWNLOAD_REPORT}`
          .replace(":code", `${code}`)
          .replace(":language", lang),
        {
          headers: {
            lang: lang,
            "Content-Type": "application/json",
          },
          responseType: "blob",
        }
      );
      return response;
    } catch (res) {
      throw res;
    }
  }

  static async getReportFeatured(params: reportFeaturedParams) {
    try {
      const response = await _APIInstance.get(`${API.REPORT.GET_FEATURED}`, {
        params: params,
        headers: {
          lang: params?.lang,
        },
      });
      return response?.data;
    } catch (res) {
      return res;
    }
  }
  static async getReportFeaturedServer(params: reportFeaturedParams) {
    try {
      const response = await _APIInstanceServer.get(
        `${API.REPORT.GET_FEATURED}`,
        {
          params: params,
          headers: {
            lang: params?.lang,
          },
        }
      );
      return response?.data;
    } catch (res) {
      return res;
    }
  }
  static async getReportBySlug(
    slug: string | undefined,
    lang: string | undefined
  ) {
    try {
      const response = await _APIInstance.get(
        `${API.REPORT.GET_ONE_BY_SLUG}`.replace(":slug", `${slug}`),
        {
          headers: {
            lang: `${lang}`,
          },
        }
      );
      return response?.data;
    } catch (response: any) {
      return response?.response?.data;
    }
  }

  static async getReportByToken(
    token: string | undefined,
    lang: string | undefined
  ) {
    try {
      const response = await _APIInstance.get(
        `${API.REPORT.GET_SHARED_DETAILS}`.replace(":token", `${token}`),
        {
          headers: {
            lang: `${lang}`,
          },
        }
      );
      return response?.data;
    } catch (response) {
      return response;
    }
  }

  static async getReportById(id: string) {
    try {
      const response = await _APIInstance.get(
        `${API.REPORT.GET_ONE_BY_ID}`.replace(":id", id)
      );
      return response?.data;
    } catch (response) {
      return response;
    }
  }
  static async getReportByIdServer(id: string) {
    try {
      const response = await _APIInstanceServer
      .get(`${API.REPORT.GET_ONE_BY_ID}`.replace(":id", id));
      return response?.data?.data;
    } catch (error:any) {
      throw error?.response?.data;
    }
  }

  static async getAllReportHomePage(params: paramsReport) {
    try {
      const response = await _APIInstance.get(`${API.REPORT.GET_ALL}`, {
        params: params,
        headers: {
          lang: params?.lang,
        },
      });
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getAllReportCommingSoon(params: paramsReport) {
    try {
      const response = await _APIInstance.get(
        `${API.REPORT.GET_ALL_COMMING_SOON}`,
        {
          params: params,
          headers: {
            lang: params?.lang,
          },
        }
      );
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getAllReportCommingSoonServer(params: paramsReport) {
    try {
      const response = await _APIInstanceServer.get(
        `${API.REPORT.GET_ALL_COMMING_SOON}`,
        {
          params: params,
          headers: {
            lang: params?.lang,
          },
        }
      );
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getAllReportHomePageServer(params: paramsReport) {
    try {
      const response = await _APIInstanceServer.get(`${API.REPORT.GET_ALL}`, {
        params: params,
        headers: {
          lang: params?.lang,
        },
      });
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getAllReportFavorite(params: paramsReport, option = {}) {
    try {
      const response = await _APIInstance.get(
        `${API.REPORT.GET_ALL_FAVORITE}`,
        {
          params: params,
          headers: {
            lang: params?.lang,
          },
          ...option,
        }
      );
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getAllReportFavoriteServer(params: paramsReport, option = {}) {
    try {
      const response = await _APIInstanceServer.get(
        `${API.REPORT.GET_ALL_FAVORITE}`,
        {
          params: params,
          headers: {
            lang: params?.lang,
          },
          ...option,
        }
      );
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async postAddFavorite(reportId: number, type: number) {
    try {
      const response = await _APIInstance.post(API.AUTH.ADD_FAVORITE, {
        reportId: reportId,
        type: type,
      });
      return response?.data?.data;
    } catch (res) {
      throw res;
    }
  }

  static async addFavorite(data: FormData) {
    return await _APIInstance
      .post(API.AUTH.ADD_FAVORITE, data)
      .then((res) => Promise.resolve(res?.data?.data))
      .catch((res) => Promise.reject(res));
  }

  static async postReportsDownload(data: FormData) {
    try {
      const response = await _APIInstance.post(API.REPORT.PORT_DOWNLOAD, data);
      return response;
    } catch (res) {
      throw res;
    }
  }

  static async getUrlNotFound(url: string) {
    try {
      const response = await _APIInstance.get(url);
      return response;
    } catch (res) {
      return res;
    }
  }

  static async getPurchasedReports(
    params: paramsPurchasedReports,
    option = {}
  ) {
    try {
      const response = await _APIInstance.get(API.PURCHASED_REPORTS.GET_ALL, {
        params: params,
        headers: {
          lang: params?.lang,
        },
        ...option,
      });
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getPurchasedReportsServer(
    params: paramsPurchasedReports,
    option = {}
  ) {
    try {
      const response = await _APIInstanceServer.get(
        API.PURCHASED_REPORTS.GET_ALL,
        {
          params: params,
          headers: {
            lang: params?.lang,
          },
          ...option,
        }
      );
      return response?.data;
    } catch (res) {
      return res;
    }
  }

  static async getReportShared(token: string | undefined) {
    try {
      const response = await _APIInstance.get(
        API.REPORT.GET_SHARED_REPORT.replace(":token", `${token}`)
      );
      return response?.data;
    } catch (response) {
      return response;
    }
  }

  static async protectedReport(data: {
    token: string | undefined;
    codePrivate: string;
  }) {
    return await _APIInstance
      .post(API.REPORT.ACCESS_PROTECTED_SHARE, data)
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async minimalReport(data: reportMinimal) {
    return await _APIInstance
      .post(API.REPORT.MINIMAL_REPORT, data)
      .then((res) => Promise.resolve(res))
      .catch((res) => Promise.resolve(res));
  }

  static async getSharedLinks(reportId: string | number) {
    return await _APIInstance
      .get(API.REPORT.GET_SHARED_BY_REPORT.replace(":reportId", `${reportId}`))
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async addSharedLink(data: FormData) {
    return await _APIInstance
      .post(API.REPORT.CREATE_SHARE, data)
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }
  static async deleteSharedLink(token: string) {
    return await _APIInstance
      .delete(API.REPORT.DELETE_SHARED_REPORT.replace(":token", `${token}`))
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async updateSharedLink(token: string | undefined, data: FormData) {
    return await _APIInstance
      .put(API.REPORT.UPDATE_SHARED_REPORT.replace(":token", `${token}`), data)
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async getReportBookmarks(params: paramsReportBookmark) {
    return await _APIInstance
      .get(API.REPORT.GET_ALL_BOOKMARKS, {
        params: params,
      })
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async addReportBookmark(data: FormData) {
    return await _APIInstance
      .post(API.REPORT.GET_ALL_BOOKMARKS, data)
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async checkLimitShare(reportId: string | number) {
    return await _APIInstance
      .get(
        API.REPORT.CHECK_LIMIT_SHARE_REPORT.replace(":reportId", `${reportId}`)
      )
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async changeNameBookmark(bookmarkId: string | number, data: FormData) {
    return await _APIInstance
      .put(
        API.REPORT.CHANGE_NAME_BOOKMARK.replace(":bookmarkId", `${bookmarkId}`),
        data
      )
      .then((res) => Promise.resolve(res?.data))
      .catch((res) => Promise.reject(res));
  }

  static async getAllRelatedReport(data: any) {
    return await _APIInstance
      .post(API.REPORT.GET_ALL_RELATED_REPORTIDS, data)
      .then((res) => Promise.resolve(res?.data?.data))
      .catch((res) => Promise.reject(res?.response?.data));
  }
}

export default ReportServices;
